import React from 'react';
import { ErrorBarra } from 'errores';

class Unsuscribe extends React.Component {
    
    constructor(props){
        super(props);
        this.state={pushChecked: false, data: this.props.match.params.data, error: false, cargando: true, checked: false, errorMensaje: ""};
        this.cerrarError.bind(this);
        this.getMarcaId.bind(this);
    }

    componentDidMount(){
        this.setState({cargando: true})
        fetch(process.env.REACT_APP_URL_DTO_BACK + "correos/cliente?data="+this.state.data, {
            method: "GET",
        }).then(async res => {
            let responseBody = await res.json();
            if (res.status < 299) {
                this.setState({ checked: responseBody.mensaje.suscribe, cargando: false });
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        }).catch(errorP => {
            console.log(errorP);
            if (errorP.toString().includes("NetworkError")) {
                this.setState({ error: true, errorMensaje: "Por el momento no podemos conectar con el servicio.", cargando: false });
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        });
    }

    getMarcaId(){
        let appID = -1
        if(this.props.marca === "vw") {
            appID = process.env.REACT_APP_ID_VW
        } else if(this.props.marca === "seat") {
            appID = process.env.REACT_APP_ID_SEAT
        } else if(this.props.marca === "audi") {
            appID = process.env.REACT_APP_ID_AUDI
        }
        return appID
    }

    enviaSuscripcion(){
        this.setState({cargando: true})
        let idAppMarca = this.getMarcaId();
        fetch(process.env.REACT_APP_URL_DTO_BACK + "correos/cliente?data="+this.state.data, {
            method: "POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({
                suscribe: !this.state.checked && this.state.pushChecked?true:false,
                idApp : idAppMarca
            })
        }).then(async res => {
            await res.json();
            if (res.status < 299) {
                this.setState({ cargando: false, errorMensaje: "Tu solicitud ha sido procesada correctamente, ya puedes cerrar la ventana del navegador." })
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        }).catch(errorP => {
            console.log(errorP);
            if (errorP.toString().includes("NetworkError")) {
                this.setState({ error: true, errorMensaje: "Por el momento no podemos conectar con el servicio.", cargando: false });
            } else {
                this.setState({ error: true, errorMensaje: "¡Ups! Algo ha pasado, favor de reintentar.", cargando: false });
            }
        });
    }

    cerrarError(){
        this.setState({ errorMensaje: "" });
    }

    render(){
        var cerrarError = this.cerrarError;
        return ( 
            <div className={"container__font--" + this.props.marca}>
                <div className={this.state.errorMensaje !== "" ? "d-block" : "d-none"}>
                    <ErrorBarra mensaje={this.state.errorMensaje} marca={this.props.marca} cerrarError={ cerrarError.bind(this) } />
                </div>
                <div className="container">
                    <div className="offset-lg-2 offset-md-2 col-xs-12 col-sm-12 col-md-8 pt-5 margin__top--titulo">
                        <h1 className="font__title--ligth text-center">¿Quieres ser contactado?</h1>
                    </div>
                    <div className="offset-lg-2 offset-md-2 col-xs-12 col-sm-12 col-md-8 mt-5">
                        <p>Nos interesa mantenerte informado, por lo que te notificaremos todo tu proceso de compra.</p>
                        <p className={this.state.checked?"d-block font-weight-bold":"d-none"}>Si ya no quieres ser contactado, solo activa la casilla.</p>
                        <p className={!this.state.checked?"d-block font-weight-bold":"d-none"}>Si quieres ser contactado, solo activa la casilla.</p>
                    </div>
                    <div className="offset-lg-3 offset-md-3 col-xs-12 col-sm-12 col-md-6 mt-5 mb-5">
                        <div className="row mb-3">
                            <div className="col-2">
                                <label className={"container_check--" + this.props.marca}>
                                    <input type="checkbox" id="2" checked={this.state.pushChecked} onChange={() => this.setState({ pushChecked: !this.state.pushChecked })} />
                                    <span className={"check--" + this.props.marca}></span>
                                </label>
                            </div>
                            <div className={"col-8 label__check--" + this.props.marca}>
                                <label htmlFor="2"><b>Correo electrónico</b></label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col mt-5">
                                <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} onClick={() => { this.enviaSuscripcion() }} name="guardar">Guardar</button>
                            </div>
                        </div>
                    </div>
                    <div className={"page__cargando page__cargando--" + this.props.marca + (this.state.cargando ? " d-block" : " d-none")}>

                    </div>
                </div>
            </div>
        );
    }
}

export default Unsuscribe;